import { Injectable, inject } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {Observable} from 'rxjs';
import {finalize, share} from 'rxjs/operators';
import {ITopVertical} from "../models/i-top-vertical";
import {ITotalClicks} from "../models/i-total-clicks";

@Injectable({
  providedIn: 'root'
})
export class StatsService {
  private http = inject(HttpClient);


  apiUrl = '/api/dashboard/';

  private inFlight = new Map<string, Observable<unknown>>();

  getTopVerticals() {
    return this.shareInFlight('topVerticals', () => this.http.get<ITopVertical[]>(`${this.apiUrl}verticals`));
  }

  getTrends() {
    return this.shareInFlight('trends', () => this.http.get<Record<string, number[]>>(`${this.apiUrl}trends`));
  }

  getTotalClicks() {
    return this.shareInFlight('totalclicks', () => this.http.get<ITotalClicks>(`${this.apiUrl}totalclicks`));
  }

  /**
   * Guard ensuring only one active HTTP call per endpoint at a time:
   * concurrent subscribers share the in-flight request instead of issuing their own.
   */
  private shareInFlight<T>(key: string, factory: () => Observable<T>): Observable<T> {
    let observable = this.inFlight.get(key) as Observable<T> | undefined;

    if (!observable) {
      observable = factory().pipe(
        finalize(() => this.inFlight.delete(key)),
        share(),
      );
      this.inFlight.set(key, observable);
    }

    return observable;
  }
}
